import { render } from "./InitialDisclosureDashboard.vue?vue&type=template&id=4bff08aa&scoped=true"
import script from "./InitialDisclosureDashboard.vue?vue&type=script&lang=js"
export * from "./InitialDisclosureDashboard.vue?vue&type=script&lang=js"

import "./InitialDisclosureDashboard.vue?vue&type=style&index=0&id=4bff08aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4bff08aa"]])

export default __exports__